export default "__VITE_ASSET__266b0699__"